import React, { useEffect, useRef, useState } from "react";
import styles from "./Banner.module.css";

const AnimatedNumbers = ({ endValue, duration, label, prefix = "", suffix = "+", isCyan = false }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    let animationFrameId;
    const handleScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const sectionVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (sectionVisible) {
        setCount(0);
        let start = 0;
        const totalSteps = duration / 16.67;
        const increment = endValue / totalSteps;

        const animate = () => {
          start += increment;
          if (start < endValue) {
            setCount(Math.ceil(start));
            animationFrameId = requestAnimationFrame(animate);
          } else {
            setCount(endValue);
          }
        };

        animationFrameId = requestAnimationFrame(animate);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger check on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
    };
  }, [endValue, duration]);

  const formatDisplay = () => {
    if (endValue >= 1000000) {
      const millions = (count / 1000000).toFixed(1);
      return `${prefix}${millions}M${suffix}`;
    }
    return `${prefix}${count.toLocaleString()}${suffix}`;
  };

  return (
    <div className={styles.statItem} ref={ref}>
      <h2 className={`${styles.statNumber} ${isCyan ? styles.cyanText : styles.whiteText}`}>
        {formatDisplay()}
      </h2>
      <p className={styles.statLabel}>{label}</p>
    </div>
  );
};

const Banner = () => {
  return (
    <div className={styles.bannerWrapper}>
      <div className={styles.statsCard}>
        <AnimatedNumbers
          endValue={1000}
          duration={1200}
          label="ENTERPRISE PROJECTS DELIVERED"
          prefix=""
          suffix="+"
          isCyan={true}
        />
        <div className={styles.divider}></div>
        <AnimatedNumbers
          endValue={1000}
          duration={1200}
          label="SENIOR TECH EXPERTS ON-BOARD"
          prefix=""
          suffix="+"
          isCyan={false}
        />
        <div className={styles.divider}></div>
        <AnimatedNumbers
          endValue={1000000}
          duration={1200}
          label="VENTURE & ENTERPRISE VALUE ENABLED"
          prefix="$"
          suffix="+"
          isCyan={false}
        />
      </div>
    </div>
  );
};

export default Banner;

